import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";

export const deleteAttributeFunc = createAsyncThunk("delete attribute function", async (attributeId) => {
  const token = window.localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.delete(`${process.env.REACT_APP_VERSEL_API}/api/dashboard/attributes/${attributeId}`, config);
    return response.data;
  } catch (error) {
    checkErrors(error.response, error.message);
  }
});

const deleteAttributeSlicer = createSlice({
  name: "delete attribute slicer",
  initialState: {
    loading: null,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteAttributeFunc.pending, (state) => {
      state.loading = true;
      state.data = {};
      state.error = false;
    });
    builder.addCase(deleteAttributeFunc.rejected, (state) => {
      state.loading = false;
      state.data = {};
      state.error = true;
    });
    builder.addCase(deleteAttributeFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = false;
    });
  },
});

export default deleteAttributeSlicer.reducer;
